import { request } from '../../xhr';
import moveArrayElement from 'lodash-move';
import snakeCase from 'lodash/snakeCase';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { updateLayoutVersion, updateModuleOrderSuccess, addModule, addModuleFail, addModuleSuccess, moveModule, removeModule, removeModuleSuccess } from '../actions/layout';
import { getZone } from '../selectors/zones';
import { getGruser } from '../selectors/gruser';
import { getPageName } from '../selectors/page';
import { getVersion } from '../selectors/layout';
import { updateModule } from '../actions/modules';
function* postLayout(endpoint, data) {
    return yield call(request, {
        method: 'post',
        url: `/layout/${endpoint}`,
        data
    });
}
export function* addModuleSaga(action) {
    const { payload } = action;
    const { zoneName, position, moduleName: module } = payload;
    const page = yield select(getPageName);
    const { username } = yield select(getGruser);
    const { installedModulesIds } = yield select(getZone, zoneName);
    const afterModuleId = installedModulesIds[position - 1];
    const params = {
        username,
        page,
        zoneName: zoneName,
        after_moduleid: afterModuleId,
        module
    };
    const response = yield call(postLayout, 'add_module', params);
    if (response && response.module) {
        yield put(addModuleSuccess(payload));
        // augment module metadata with a special flag
        yield put(updateModule({
            id: response.module.id,
            moduleMeta: {
                isNewlyAdded: true
            }
        }));
        const order = [
            ...installedModulesIds
        ];
        order.splice(position, 0, response.module.id);
        yield put(updateModuleOrderSuccess({
            zoneName,
            order
        }));
        yield put(updateLayoutVersion({
            version: response.layoutVersion
        }));
    } else {
        yield put(addModuleFail(payload));
    }
}
export function* removeModuleSaga(action) {
    const { zoneName, moduleId } = action.payload;
    const page = yield select(getPageName);
    const { username } = yield select(getGruser);
    const version = yield select(getVersion);
    const params = {
        username,
        page,
        zoneName: snakeCase(zoneName),
        moduleid: moduleId,
        version
    };
    const response = yield call(postLayout, 'remove_module', params);
    if (response) {
        var _installedModulesIds;
        const { installedModulesIds } = yield select(getZone, zoneName);
        const order = (_installedModulesIds = installedModulesIds) === null || _installedModulesIds === void 0 ? void 0 : _installedModulesIds.filter((id)=>id !== moduleId);
        yield put(updateModuleOrderSuccess({
            zoneName,
            order
        }));
        yield put(removeModuleSuccess(action.payload));
        yield put(updateLayoutVersion({
            version: response.layoutVersion
        }));
    }
}
export function* moveModuleSaga(action) {
    const { zoneName, moduleId, position } = action.payload;
    const { username } = yield select(getGruser);
    const version = yield select(getVersion);
    const { installedModulesIds } = yield select(getZone, zoneName);
    // imagine the drag item is pulled up and the rest items in the stack filled the gap
    const installedModulesIdsWithoutCurrent = installedModulesIds.filter((id)=>id !== moduleId);
    // now we can find out what module it will go after to be on the desired position
    const afterModuleId = installedModulesIdsWithoutCurrent[position - 1];
    const response = yield call(postLayout, 'move_module', {
        username,
        moduleid: moduleId,
        after_moduleid: afterModuleId,
        version
    });
    if (response) {
        const currentModuleIndex = installedModulesIds.indexOf(moduleId);
        const order = moveArrayElement(installedModulesIds, currentModuleIndex, position);
        yield put(updateModuleOrderSuccess({
            zoneName,
            order
        }));
        yield put(updateLayoutVersion({
            version: response.layoutVersion
        }));
    }
}
export default function* rootLayoutSaga() {
    yield all([
        takeEvery(addModule, addModuleSaga),
        takeEvery(removeModule, removeModuleSaga),
        takeEvery(moveModule, moveModuleSaga)
    ]);
}
